<template>
  <el-dialog :visible.sync="visible"
             title="设为离职">
    <div style="text-align: center;">
      <div>确定要将“{{dataForm.name}}”设为离职吗？</div>
      <br/>
      <br/>
      <div>可从离职员工中恢复</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dataFormSubmitHandle()">确 定</el-button>
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      dataListLoading: false,
      dataForm: {
        name: '',
        custId: ''
      }
    }
  },
  methods: {
    init () {
      this.visible = true
    },
    // 确定
    dataFormSubmitHandle () {
      if (this.dataListLoading) {
        return true
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/custorg/resign/${this.dataForm.custId}`)
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code === 0) {
            this.visible = false
            this.$message.success('操作成功')
            this.$emit('refreshDataList')
          }
        }).catch(() => {
          this.dataListLoading = false
        })
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
